import mailIcon from './src/at-solid.svg'
import addressIcon from './src/location-dot-solid.svg'
import telIcon from './src/phone-solid.svg'

import close from './src/x-solid.svg'

import './about.scss'

import { useSelector, useDispatch } from 'react-redux'
import { setShowAbout } from "../../../../redux/mainPageSlice"

export default function About() {
	const dispatch = useDispatch()
	const handleAbout = () => {
		dispatch(setShowAbout(false))
		const event = new CustomEvent('liquid', { detail: false });
		window.dispatchEvent(event);
	}
  return (
	<>
		  <div className="about-page" id="about">
			  <img className="close" height={20} src={close} alt="close" style={{ position: "fixed", right: "50px", top: "50px" }} onClick={handleAbout} />
			  <div className="d-flex ">
				  <div>
					  <h1>Mudakikwa Julio Fred</h1>
					  <div className="about-description">
						  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
						  <div className="contact-list">
							  <div className="contact">
								  <img src={addressIcon} height={20} alt='address' />
								  <p>KN 170 Ave</p>
							  </div>
							  <div className="contact">
								  <img src={mailIcon} height={20} alt='email' />
								  <p>trialanderror@gmail.com</p>
							  </div>
							  <div className="contact">
								  <img src={telIcon} height={20} alt='telephone' />
								  <p>+250 788 888 888</p>
							  </div>
						  </div>
					  </div>
				  </div>
				  <div className="me-img"></div>
			  </div>
		  </div>
	</>
  )
}
